import i18n from 'i18next';

const STATUS_DATA = {
  completed: { labelKey: 'memory.status.completed', active: true },
  pending: { labelKey: 'memory.status.pending', active: false }
};
const STATUS_NAMESPACE = 'ChatbotIA';

const getStatusMeta = (status) => {
  if (!status) return null;
  const key = String(status).toLowerCase();

  if (STATUS_DATA[key]) {
    const { labelKey, active } = STATUS_DATA[key];
    const label = i18n.exists(labelKey, { ns: STATUS_NAMESPACE })
      ? i18n.t(labelKey, { ns: STATUS_NAMESPACE })
      : i18n.t(labelKey);
    return { label, active };
  }

  return {
    label: status.replace(/_/g, ' '),
    active: false
  };
};

export { STATUS_DATA, getStatusMeta };
